module.exports = __webpack_public_path__ + "img/thumbs-up-white.79aaf235.svg";